<!-- コース毎　予約枠マスタ　詳細画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<style scoped>
  /* コース別予約枠があるレコード　*/
  .kswkListOn {

  }
  /* 編集中のレコード */
  .kswkListEdit {
      background-color: red
  }

</style>
<template>
  <div class="contents" id="wirks">
    <!-- ▽ -->
    <section id="mainContent">
      <h2>コース毎　予約枠マスタ</h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>

      <!-- ▽ -->
      <section class="inputArea">
        <table class="inputTbl" id="wkswk">
          <caption>
            <ul class="listClass">
              <li><b>クライアント</b>{{jgnm}}</li>
              <li><b>年度</b>{{nend}}</li>
              <li><b>コース</b>{{ksnm}}</li>
            </ul>
            <div class="btnLst">
              <button class="newBtn" v-on:click="onAddRecord">追加</button>
              <button class="confBtn" v-on:click="onConfirmUpdateModalOpen">更新</button>        
            </div>
          </caption>
          <thead>
            <tr><th>対象者区分</th><td>性別</td><td>年齢範囲</td><td>予約枠</td><td></td></tr>
          </thead>
          <tbody>
            <tr v-for="(list, index) in listKswk" v-bind:key="list.recordDisplayKeyCount" v-bind:class="getClassNameByRecordStatuses(index)">
              <th>
                <select v-model="list.hfkb" v-on:change="changeRecord(index)">
                  <option value="0">▼ 選択してください</option>
                  <option v-for="item in listHfkb" v-bind:value="item.hfkb" v-bind:key="item.hfkb">
                    {{item.kbnm}}
                  </option>
                </select>
              </th>
              <td>
                <select v-model="list.sex" v-on:change="changeRecord(index)">
                  <option value="0"></option>
                  <option v-for="item in listSex" v-bind:value="item.code" v-bind:key="item.code">
                    {{item.name}}
                  </option>
                </select>
              </td>
              <td class="old">
                <input type="text" maxlength="3" placeholder="XXX" v-model="list.stag" v-on:change="changeRecord(index)"> ～ <input type="text" maxlength="3" placeholder="XXX" v-model="list.edag" v-on:change="changeRecord(index)">
              </td>
              <td>
                <select v-model="list.waku" v-on:change="changeRecord(index)">
                  <option value="0000"></option>
                  <option v-for="item in listWaku" v-bind:value="item.waku" v-bind:key="item.waku">
                    {{item.wknm}}
                  </option>
                </select>
              </td>
              <td class="btnLst">
                <button class="dltBtn" v-on:click="onConfirmDeleteModalOpen(index)">削除</button>
              </td>
            </tr>
          </tbody>
        </table>
        <!--データが一件もない場合に表示-->
        <div v-if="listKswk.length == 0">
          <p>データが一件も登録されていません。</p>
        </div>
      </section>
      <!-- △  END -->
    </section>
    <!-- △ mainContents END -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
      <dt slot="modal-header">入力エラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
      <dt slot="modal-header">システムエラー</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
      </dd>
      <dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.confirmUpdate.isShow" v-on:close="onConfirmUpdateModalClose">
      <dt slot="modal-header">確認</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.confirmUpdate.messages"></errorMessageBox>
        <ul class="btnLst">
          <li><button v-on:click="onUpdate">OK</button></li>
          <li><button v-on:click="onConfirmUpdateModalClose">キャンセル</button></li>
        </ul>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
    <!-- モーダルWindow S -->
    <modalWindow v-show="modal.confirmDelete.isShow" v-on:close="onConfirmDeleteModalClose">
      <dt slot="modal-header">確認</dt>
      <dd slot="modal-body">
        <errorMessageBox :errorMessages="modal.confirmDelete.messages"></errorMessageBox>
        <ul class="btnLst">
          <li><button v-on:click="onDelete">OK</button></li>
          <li><button v-on:click="onConfirmDeleteModalClose">キャンセル</button></li>
        </ul>
      </dd>
    </modalWindow>
    <!-- モーダルWindow E -->
  </div>
</template>
<script>
  import { WKSWKApi } from '@/api'
  import * as types from '@/store/mutation-types'
  import * as ErrorCodes from '@/components/Utility/error-codes'
  import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
  import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

  export default {
    // モジュール名
    name: 'MasterWKSWK',
    // 使用コンポーネント
    components: {
      // エラーメッセージ
      errorMessageBox: ErrorMessageBox,
      // モーダルウィンドウ
      modalWindow: ModalWindow,
    },
    // データ
    data() {
      return {
        // クライアント名
        jgnm: '',
        // 年度
        nend: 0,
        // コース名
        ksnm: '',

        // 対象者区分プルダウン作成用リスト
        // hfkb: 対象者区分コード
        // kbnm: 名称
        listHfkb: [],

        // 性別プルダウン作成用リスト
        // code: コード値
        // name: 性別名
        listSex: [
          { code:'Z', name:'共通' },
          { code:'1', name:'男性' },
          { code:'2', name:'女性' },
        ],

        // 予約枠プルダウン作成用リスト
        // waku: 予約枠
        // wknm: 予約枠名
        listWaku: [],

        // コース毎予約枠リスト
        // jkcd: 条件コード
        // hfkb: 対象者区分
        // sex: 性別
        // stag: 開始年齢
        // edag: 終了年齢
        // waku: 予約枠
        // recordStatus: レコードステータス
        // 0: WKSWKが存在する、初期表示、更新、削除の再描画時直後
        // 12: 画面でWKSWKを更新した場合
        // 13: 画面でレコードを追加した場合
        // recordDisplayKeyCount: レコードキー
        // （画面上でレコード識別するための一意のキー）
        listKswk: [],

        // 削除レコード識別用条件コード
        deleteRecordIndex: 0,

        // モーダルウィンドウ
        modal: {
          validationError: {
            messages: [],
            isShow: false
          },
          systemError: {
            messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
            isShow: false
          },
          confirmUpdate: {
            messages: [
							'更新しますか？'
						],
            isShow: false
          },
          confirmDelete: {
            messages: [
              '削除しますか？'
            ],
            isShow: false
          },
        }
      }
    },
    // ライフサイクルハック　初期化
    created: function () {
      UtilityConsoleLog.consoleLog('MasterWKSWK::created Start')

      this.firstDisplay()

      UtilityConsoleLog.consoleLog('MasterWKSWK::created End')
    },
    methods: {
      // 初期表示
      firstDisplay: function() {
        UtilityConsoleLog.consoleLog("MasterWKSWK::firstDisplay Start")

        // 非同期通信
        WKSWKApi.FirstDisplay({
          token: this.$store.state.auth.token,
          nend: this.$store.state.adminUserChoice.MasterWIRKS.nend,
          ircd: this.$store.state.auth.ircd,
          jgcd: this.$store.state.adminUserChoice.MasterWIRKS.jgcd,
          kscd: this.$store.state.adminUserChoice.MasterWIRKS.kscd,
          key: this.$store.state.adminUserChoice.MasterWIRKS.key
        }).then(({ responce }) => {

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            this.jgnm = responce.data.jgnm
            this.nend = this.$store.state.adminUserChoice.MasterWIRKS.nend
            this.ksnm = responce.data.ksnm

            // 対象者区分プルダウン作成用リスト
            this.listHfkb = []
            // 最初に'Z':共通
            this.listHfkb.push({
              hfkb: 'Z',
              kbnm: '共通'
            })
            // レスポンスからデータを挿入
            responce.data.listHfkb.forEach(item =>{
              this.listHfkb.push(item)
            })

            // 予約枠プルダウン作成用リスト
            this.listWaku = responce.data.listWaku

            // コース毎予約枠リスト
            this.listKswk = responce.data.listKswk

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            // システム、DBエラー時
            this.onSystemErrorModalOpen()
          }
        }).catch(() => {
          // システムエラー時
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('MasterWKSWK::firstDisplay End')
	      })
      },
      // 更新
      onUpdate: function() {
        UtilityConsoleLog.consoleLog("MasterWKSWK::onUpdate Start")

        // 非同期通信
        WKSWKApi.Update({
          token: this.$store.state.auth.token,
          ircd: this.$store.state.auth.ircd,
          key: this.$store.state.adminUserChoice.MasterWIRKS.key,
          jkcds: this.getJkcds(),
          hfkbs: this.getHfkbs(),
          sexes: this.getSexes(),
          stags: this.getStags(),
          edags: this.getEdags(),
          wakus: this.getWakus(),
          recordStatuses: this.getRecordStatuses()
        }).then(({ responce }) => {

            if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

              //更新確認モーダルを閉じる
              this.onConfirmUpdateModalClose()
              // コース毎予約枠リスト再取得
              this.listKswk = responce.data.listKswk

            } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM) {
              this.onValidationErrorModalOpen(responce.data.errorMessagesList)
            } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTCORRECTION) {
              this.onValidationErrorModalOpen(responce.data.errorMessagesList)
            } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
              || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
              // システム、DBエラー時
              this.onSystemErrorModalOpen()
            }
        }).catch(() => {
          // システムエラー時
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('MasterWKSWK::onUpdate End')
	      })
      },
      // 削除
      onDelete: function() {

        UtilityConsoleLog.consoleLog("MasterWKSWK::onDelete Start")

        // recordStatus：13 画面で追加したレコードの場合
        if('13' == this.listKswk[this.deleteRecordIndex].recordStatus) {
          this.listKswk.splice(this.deleteRecordIndex,1)
          this.onConfirmDeleteModalClose()
          return;
        }

        // 非同期通信
        WKSWKApi.Delete({
          token: this.$store.state.auth.token,
          ircd:  this.$store.state.auth.ircd,
          key:   this.$store.state.adminUserChoice.MasterWIRKS.key,
          jkcd:  this.listKswk[this.deleteRecordIndex].jkcd
        }).then(({ responce }) => {

          this.deleteRecordIndex = 0

          if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

            // コース毎予約枠リスト再取得
            this.listKswk = responce.data.listKswk

            // 削除確認モーダルを閉じる
            this.onConfirmDeleteModalClose()

          } else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
            || responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
            // システム、DBエラー時
            this.onSystemErrorModalOpen()
          }
        }).catch(() => {
          // システムエラー時
          this.onSystemErrorModalOpen()
        }).finally(() => {
	        UtilityConsoleLog.consoleLog('MasterWKSWK::onDelete End')
	      })
      },
      // 追加
      onAddRecord: function() {

        UtilityConsoleLog.consoleLog("MasterWKSWK::onAddRecord Start")

        // 末尾にデータ追加
        this.listKswk.push({
          jkcd: '00',
          hfkb: '0',
          sex: '0',
          stag: 0,
          edag: 0,
          waku: '0000',
          recordStatus: '13'
        })

        UtilityConsoleLog.consoleLog('MasterWKSWK::onAddRecord End')

      },
      // キャンセル
      onCancel: function () {
        UtilityConsoleLog.consoleLog("MasterWKSWK::onCancel Start")

        this.$store.commit(types.ADMIN_USERCHOICE_WIRKS_BACKTOLIST)

        this.$router.push("/MasterWIRKSList")

        UtilityConsoleLog.consoleLog("MasterWKSWK::onCancel End")        
      },
      // 現在のjkcdを配列で返す
      getJkcds: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::getJkcds Start')

        var resultJkcds = []

        for(var i=0;i<this.listKswk.length;i++){
          resultJkcds.push(this.listKswk[i].jkcd)
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::getJkcds End')

        return resultJkcds
      },
      // 現在のhfkbを配列で返す
      getHfkbs: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::getHfkbs Start')

        var resultHfkbs = []

        for(var i=0;i<this.listKswk.length;i++){
          resultHfkbs.push(this.listKswk[i].hfkb)
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::getHfkbs End')

        return resultHfkbs
      },
      // 現在のsexを配列で返す
      getSexes: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::getSexes Start')

        var resultSexes = []

        for(var i=0;i<this.listKswk.length;i++){
          resultSexes.push(this.listKswk[i].sex)
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::getSexes End')

        return resultSexes
      },
      // 現在のstagを配列で返す
      getStags: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::getStags Start')

        var resultStags = []

        for(var i=0;i<this.listKswk.length;i++){
          resultStags.push(
            this.checkNumber(this.listKswk[i].stag))
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::getStags End')

        return resultStags
      },
      // 現在のedagを配列で返す
      getEdags: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::getEdags Start')

        var resultEdags = []

        for(var i=0;i<this.listKswk.length;i++){
          resultEdags.push(
            this.checkNumber(this.listKswk[i].edag))
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::getEdags End')

        return resultEdags
      },
      // 現在のwakuを配列で返す
      getWakus: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::getWakus Start')

        var resultWakus = []

        for(var i=0;i<this.listKswk.length;i++){
          resultWakus.push(this.listKswk[i].waku)
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::getWakus End')

        return resultWakus
      },
      // 現在のrecordStatusを配列で返す
      getRecordStatuses: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::getRecordStatuses Start')

        var resultRecordStatuses = []

        for(var i=0;i<this.listKswk.length;i++){
          resultRecordStatuses.push(this.listKswk[i].recordStatus)
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::getRecordStatuses End')

        return resultRecordStatuses
      },
      // レコードに変更があったとき
      changeRecord: function(index) {
        UtilityConsoleLog.consoleLog('MasterWKSWK::changeRecord Start')

        if('0' == this.listKswk[index].recordStatus) {
          this.listKswk[index].recordStatus = '12'
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::changeRecord End')
      },
      // recordStatusによってクラスを設定する
      getClassNameByRecordStatuses: function(index) {
        
        var resultClassName = ''
        
        if('0' == this.listKswk[index].recordStatus) {
          resultClassName = 'kswkListOn'
        } else if ('12' == this.listKswk[index].recordStatus
                    || '13' == this.listKswk[index].recordStatus) {
          resultClassName = 'kswkListEdit'
        }

        return resultClassName
      },
      // Number型がString型になっていた場合数値に直して返す
      checkNumber: function (value0) {

        UtilityConsoleLog.consoleLog('MasterWKSWK::checkNumber Start')

        var tempType = typeof value0
        var tempValue = 0

        if (tempType == 'number') {
          tempValue = value0
        } else {

          var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
          var flagNumber = regexp.test(value0)

          // 文字列型の数値ではないとき
          if (!flagNumber) {
            tempValue = -1
          } else {
            tempValue = Number(value0)
          }
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::checkNumber End')

        return tempValue
      },
      // バリデーションエラーモーダルとしてエラーモーダルを開く
      // errorMessagesは文字列配列であること
      // errorMessages = [
      //  'エラーメッセージ'
      // ]
      onValidationErrorModalOpen: function (errorMessages) {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
        this.modalOpen('validationError')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onValidationErrorModalOpen End')
      },
      // バリデーションエラーモーダルとしてエラーモーダルを閉じる
      onValidationErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onValidationErrorModalClose Start')

        this.modalClose('validationError')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onValidationErrorModalClose End')
      },
      // システムエラーモーダルとしてエラーモーダルを開く
      onSystemErrorModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onSystemErrorModalOpen Start')

        this.modalOpen('systemError')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onSystemErrorModalOpen End')
      },
      // システムエラーモーダルウィンドウの閉じるボタン
      onSystemErrorModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onSystemErrorModalClose Start')

        this.modalClose('systemError')
        this.$router.push('/AdminLogin')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onSystemErrorModalClose End')
      },
      // 更新ボタン押下時（更新ダイアログを開く前）
      validationOnUpdate: function(){

        UtilityConsoleLog.consoleLog('MasterWKSWK::validationOnUpdate Start')

        // フロント用エラーメッセージ
        var resultErrorMessages = []

        // 年齢範囲開始の数値チェック
        for(var i=0;i<this.listKswk.length;i++){
          var tempStag = this.checkNumber(this.listKswk[i].stag)
          if (tempStag == -1) {
            resultErrorMessages.push( String(i + 1) + '行目の年齢範囲開始は整数値で入力してください。')
          }
        }

        // 年齢範囲終了の数値チェック
        for(var i=0;i<this.listKswk.length;i++){
          var tempEdag = this.checkNumber(this.listKswk[i].edag)
          if (tempEdag == -1) {
            resultErrorMessages.push( String(i + 1) + '行目の年齢範囲終了は整数値で入力してください。')
          }
        }

        UtilityConsoleLog.consoleLog('MasterWKSWK::validationOnUpdate End')

        return resultErrorMessages
      },
      // 更新確認モーダルを開く
      onConfirmUpdateModalOpen: function () {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmUpdateModalOpen Start')

        // フロント用エラーメッセージ
        var tempErrorMessages = []
        // 入力チェック
        tempErrorMessages = this.validationOnUpdate()

        // 一件でもエラーがあれば入力エラーモーダルウィンドウを開き、処理を中断する
        if( tempErrorMessages.length > 0 ){
          this.onValidationErrorModalOpen(tempErrorMessages)
          return
        }

        this.modalOpen('confirmUpdate')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmUpdateModalOpen End')
      },
      // 更新確認モーダルを閉じる
      onConfirmUpdateModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmUpdateModalClose Start')

        this.modalClose('confirmUpdate')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmUpdateModalClose End')
      },
      // 削除確認モーダルを開く
      onConfirmDeleteModalOpen: function (index) {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmDeleteModalOpen Start')

        this.deleteRecordIndex = index

        this.modalOpen('confirmDelete')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmDeleteModalOpen End')
      },
      // 削除確認モーダルを閉じる
      onConfirmDeleteModalClose: function () {
        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmDeleteModalClose Start')

        this.deleteRecordIndex = 0
        this.modalClose('confirmDelete')

        UtilityConsoleLog.consoleLog('MasterWKSWK::onConfirmDeleteModalClose End')
      },
      // モーダルウィンドウを開く
      modalOpen: function (modalName) {
        UtilityConsoleLog.consoleLog('MasterWKSWK::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

        this.modal[modalName].isShow = true

        UtilityConsoleLog.consoleLog('MasterWKSWK::modalOpen End')
      },
      // モーダルウィンドウを閉じる
      modalClose: function (modalName) {
        UtilityConsoleLog.consoleLog('MasterWKSWK::modalClose Start')

        this.modal[modalName].isShow = false

        UtilityConsoleLog.consoleLog('MasterWKSWK::modalClose End')
      },
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIRKS/MasterWKSWK.vue